var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_13123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_32_13123)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32_13123",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4702 0.539062H0.470215V16.5391H16.4702V0.539062Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32_13123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47021 16.5391C12.8885 16.5391 16.4702 12.9574 16.4702 8.53906C16.4702 4.12078 12.8885 0.539062 8.47021 0.539062C4.05193 0.539062 0.470215 4.12078 0.470215 8.53906C0.470215 12.9574 4.05193 16.5391 8.47021 16.5391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12256 8.53863H16.4704C16.4704 7.81657 16.3741 7.11707 16.1948 6.45166H8.12256V8.53863Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12256 4.3648H15.2962C14.8064 3.56568 14.1803 2.85933 13.4502 2.27783H8.12256V4.3648Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47011 16.539C10.3529 16.539 12.0835 15.8882 13.45 14.7998H3.49023C4.8568 15.8882 6.58733 16.539 8.47011 16.539Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64469 12.713H15.2964C15.6895 12.0715 15.9944 11.3702 16.1949 10.626H0.746094C0.946625 11.3702 1.25153 12.0715 1.64469 12.713Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17596 1.78837H4.90499L4.22687 2.28103L4.4859 3.07818L3.8078 2.58553L3.12971 3.07818L3.35346 2.38953C2.7564 2.88687 2.23308 3.46956 1.80183 4.11881H2.03543L1.60377 4.4324C1.53652 4.54459 1.47202 4.65856 1.41021 4.77422L1.61633 5.40862L1.23178 5.12922C1.13618 5.33175 1.04875 5.53884 0.970153 5.75025L1.19725 6.44925H2.03543L1.35731 6.9419L1.61633 7.73906L0.938246 7.2464L0.532059 7.54153C0.491402 7.86834 0.470215 8.20122 0.470215 8.53906H8.47021C8.47021 4.12081 8.47021 3.59993 8.47021 0.539062C6.88984 0.539062 5.41663 0.997501 4.17596 1.78837ZM4.4859 7.73906L3.8078 7.2464L3.12971 7.73906L3.38874 6.9419L2.71062 6.44925H3.5488L3.8078 5.65209L4.0668 6.44925H4.90499L4.22687 6.9419L4.4859 7.73906ZM4.22687 4.61147L4.4859 5.40862L3.8078 4.91597L3.12971 5.40862L3.38874 4.61147L2.71062 4.11881H3.5488L3.8078 3.32165L4.0668 4.11881H4.90499L4.22687 4.61147ZM7.35546 7.73906L6.67737 7.2464L5.99927 7.73906L6.25831 6.9419L5.58018 6.44925H6.41838L6.67737 5.65209L6.93637 6.44925H7.77455L7.09644 6.9419L7.35546 7.73906ZM7.09644 4.61147L7.35546 5.40862L6.67737 4.91597L5.99927 5.40862L6.25831 4.61147L5.58018 4.11881H6.41838L6.67737 3.32165L6.93637 4.11881H7.77455L7.09644 4.61147ZM7.09644 2.28103L7.35546 3.07818L6.67737 2.58553L5.99927 3.07818L6.25831 2.28103L5.58018 1.78837H6.41838L6.67737 0.991219L6.93637 1.78837H7.77455L7.09644 2.28103Z",
    fill: "#0052B4"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_13123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.470215 0.539062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_32_13123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.470215 0.539062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdIcon);
export default __webpack_public_path__ + "static/media/usd-icon.8c1741cab08b60597d9c4b023be6ef8b.svg";
export { ForwardRef as ReactComponent };